import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { styled, Typography, Drawer as MUIDrawer, Divider, } from "@mui/material";
import { IconButton } from "../IconButton";
import { convertPxToRem } from "../../util-functions";
import { Button } from "../Button";
const StyledDrawerContainer = styled(MUIDrawer)(({ theme }) => ({
    "& .MuiDrawer-paper": {
        width: convertPxToRem(600),
        borderTopLeftRadius: convertPxToRem(18),
        borderBottomLeftRadius: convertPxToRem(18),
        [theme.breakpoints.down("sm")]: {
            width: "100%",
        },
    },
}));
export const StyledHeaderContainer = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    paddingLeft: convertPxToRem(16),
    paddingRight: convertPxToRem(16),
    minHeight: convertPxToRem(64),
    borderBottom: `${convertPxToRem(1)} solid ${theme.palette.grey04.main}`,
}));
const StyledBodyContainer = styled("div")({
    overflowY: "scroll",
    paddingLeft: convertPxToRem(32),
    paddingRight: convertPxToRem(32),
    paddingTop: convertPxToRem(32),
});
const StyledFooterContainer = styled("div", {
    shouldForwardProp: (prop) => prop !== "secondaryButton",
})(({ secondaryButton, theme }) => ({
    marginTop: "auto",
    padding: `${convertPxToRem(8)} ${convertPxToRem(32)}`,
    minHeight: convertPxToRem(64),
    borderTop: `${convertPxToRem(1)} solid ${theme.palette.grey04.main}`,
    display: "flex",
    gap: convertPxToRem(20),
    justifyContent: "flex-end",
    alignItems: "center",
    button: {
        width: secondaryButton ? "100%" : "auto",
    },
}));
const StyledHeaderTitle = styled("div")({
    width: convertPxToRem(189.33),
    display: "flex",
    justifyContent: "center",
    wordBreak: "break-word",
});
const StyledCloseButtonContainer = styled("div")({
    width: convertPxToRem(189.33),
    display: "flex",
    justifyContent: "flex-end",
});
const StyledTertiaryTitle = styled("div")({
    width: convertPxToRem(189.33),
});
const StyledDrawerContent = styled("div")({
    marginBottom: convertPxToRem(32),
});
export const DrawerContent = ({ children, divider = false, }) => (_jsxs(_Fragment, { children: [_jsx(StyledDrawerContent, Object.assign({ "data-testid": "drawer-content" }, { children: children })), divider && _jsx(Divider, { "data-testid": "drawer-content-divider" })] }));
export const Drawer = ({ children, onClose, open, primaryButtonProps, secondaryButtonProps, tertiaryButtonProps, testId, title, }) => (_jsxs(StyledDrawerContainer, Object.assign({ anchor: "right", open: open, onClose: onClose, variant: "temporary", "data-testid": testId }, { children: [_jsxs(StyledHeaderContainer, Object.assign({ "data-testid": "drawer-header" }, { children: [_jsx(StyledTertiaryTitle, { children: tertiaryButtonProps && (_jsx(Button, Object.assign({ testId: testId && `tertiaryButton-${testId}`, variant: "text" }, tertiaryButtonProps))) }), _jsx(StyledHeaderTitle, { children: _jsx(Typography, Object.assign({ variant: "h6" }, { children: title })) }), _jsx(StyledCloseButtonContainer, { children: _jsx(IconButton, { variant: "secondary", size: "small", iconName: "Close", testId: "drawer-close-button", onClick: (event) => onClose === null || onClose === void 0 ? void 0 : onClose(event, "escapeKeyDown") }) })] })), _jsx(StyledBodyContainer, Object.assign({ "data-testid": "drawer-body-container" }, { children: children })), _jsxs(StyledFooterContainer, Object.assign({ "data-testid": "drawer-footer", secondaryButton: secondaryButtonProps }, { children: [secondaryButtonProps && (_jsx(Button, Object.assign({ testId: testId && `secondaryButton-${testId}`, variant: "secondary" }, secondaryButtonProps))), primaryButtonProps && (_jsx(Button, Object.assign({ testId: testId && `primaryButton-${testId}`, variant: "primary" }, primaryButtonProps)))] }))] })));
